import React from 'react';
import { KatLayout, KatButton } from '@amzn/katal-react';
import { SiteSelector } from './SiteSelector';
import { GSLADataTable } from './GSLADataTable';
import { UploadButton } from './UploadButton';
import { HandlingTierSelector } from './HandlingTierSelector';

interface MainContentProps {
    onSiteSelect: (siteIds: string[]) => void;
    onExport: () => void;
    isLoading: boolean;
    columns: any[];
    data: any[];
    tableRef: React.RefObject<any>;
    isAuthorized: boolean;
    selectedHandlingTier: string;
    onHandlingTierChange: (tier: string) => void;
    availableTiers?: string[];
}

export const MainContent: React.FC<MainContentProps> = ({
    onSiteSelect,
    onExport,
    isLoading,
    columns,
    data,
    tableRef,
    isAuthorized,
    selectedHandlingTier,
    onHandlingTierChange,
    availableTiers
}) => (
    <React.Fragment>
        <KatLayout>
            <div slot='main'>
                <SiteSelector onSiteSelect={onSiteSelect} />
                <HandlingTierSelector 
                    selectedTier={selectedHandlingTier}
                    onTierChange={onHandlingTierChange}
                    availableTiers={availableTiers}
                />
                <KatButton
                    variant="primary"
                    onClick={onExport}
                    disabled={isLoading}
                >Export CSV</KatButton>
                {isAuthorized && <UploadButton/>}
                <GSLADataTable 
                    columns={columns} 
                    data={data} 
                    tableRef={tableRef}
                />
            </div>
        </KatLayout>
    </React.Fragment>
);
